import ActionTypes from './types';

const register = (user) => ({
  type: ActionTypes.REGISTER_REQUEST,
  payload: { user },
});

const login = (user) => ({
  type: ActionTypes.LOGIN_REQUEST,
  payload: { user },
});

const logout = () => ({
  type: ActionTypes.LOGOUT_REQUEST,
});

const updateUser = (attributes) => ({
  type: ActionTypes.USER_UPDATE_REQUEST,
  payload: { attributes },
});

const updateUserImg = (img) => ({
  type: ActionTypes.USER_UPDATE_IMG_REQUEST,
  payload: { img },
});

const userActions = {
  register,
  login,
  logout,
  updateUser,
  updateUserImg,
};

export default userActions;
